/* eslint jsx-a11y/anchor-is-valid: 0 */
import { useContext, useState } from "react";
import { ActionType } from "../State/State";
import { AppContext } from "../State/Context";
import { rootURL } from "../utils/settings";
import { BasicPopup } from "./BasicPopup";

export const LoginPopup: React.FC = () => {
  const { dispatch, state } = useContext(AppContext);
  const closePopup = () => {
    dispatch({ type: ActionType.TOGGLE_LOGIN_POPUP });
  };

  const isLocalStorageTOSAccepted = localStorage.getItem("tos") === "true";
  const [isTOSAccepted, setIsTOSAccepted] = useState<boolean>(
    isLocalStorageTOSAccepted
  );
  const [isCookiesAccepted, setIsCookiesAccepted] = useState<boolean>(
    isLocalStorageTOSAccepted
  );

  const onTOSChange = () => {
    setIsTOSAccepted(!isTOSAccepted);
  };

  const onCookiesChange = () => {
    setIsCookiesAccepted(!isCookiesAccepted);
  };

  const onLogin = () => {
    if (isTOSAccepted && isCookiesAccepted) {
      localStorage.setItem("tos", "true");
      window.location.href = rootURL + "/api/auth/google/";
    }
  };

  return state.isLoginPopupOpen ? (
    <BasicPopup onClose={closePopup}>
      <div className="pb-1">
        <div className="font-bold text-lg my-3 flex items-center">
          <span className="text-2xl mx-2">🔥</span> Welcome to the AI-powered World!
        </div>
        <div className="mb-6">
          This is a game where every player can generate their own piece of the
          world using Artificial Intelligence.
        </div>
        <div className="mb-3">
          <div className="font-bold mb-2">How to play</div>
          <ol className="list-decimal list-inside space-y-2">
            <li>Drag the map to the edge of the world.</li>
            <li>Select an empty hexagon next to an existing tile.</li>
            <li>Enter a prompt and check the cost before generating.</li>
          </ol>
          <p className="mt-4">
            First registration grants 600 points once. Upvotes and time spent
            in the game do not grant more points. Sparks purchases and email
            sending are disabled.
          </p>
        </div>

        <div className="text-xs mt-5 mb-5 flex">
          <div className="w-8">
            <input
              onChange={onTOSChange}
              type="checkbox"
              checked={isTOSAccepted}
              className="mr-2 h-5 w-5"
            />
          </div>
          <div className="">
            I have read and agree to the 
            <a href="/tos.txt" target="_blank">
              Terms of Service
            </a>
            .
          </div>
        </div>
        <div className="text-xs flex">
          <div className="w-8">
            <input
              onChange={onCookiesChange}
              type="checkbox"
              className="mr-2 h-5 w-5"
              checked={isCookiesAccepted}
            />
          </div>
          <div className="ml-2">
            I consent to the use of cookies as described in the <a href="/cookies.txt" target="_blank">Cookie Policy</a>.
          </div>
        </div>
        <div
          className={
            "mt-6 opacity-40" +
            (isTOSAccepted && isCookiesAccepted ? "disabled" : "")
          }
        >
          <a
            onClick={(e) => {
              e.preventDefault();
              if (window.self !== window.top) {
                window.open("https://hexagen.world", "_blank");
              } else {
                onLogin();
              }
            }}
            href="#"
            className={
              "button py-1 px-2 pointer-events-none " +
              (isTOSAccepted && isCookiesAccepted && "pointer-events-auto")
            }
          >
            Auth with Google Account
          </a>
        </div>
      </div>
    </BasicPopup>
  ) : null;
};
